import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  FormLabel,
  Heading,
  VStack,
  Text,
  Select as ChakraSelect,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  closeCreateSubjectAssistPhone,
} from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import {
  createSubjectAssistPhoneRequest,
  editSubjectAssistPhoneRequest,
} from "../../../../modules/admin-modules/subject-assist-phones/Actions";
import Select from "react-select";

const AddSubjectAssistPhone = ({ isAdd, data, setSelectedData }) => {
  const openPhone = useSelector((state) => state.model.isOpen40);
  const isLoading = useSelector((state) => state.subjectAssistPhones.isLoading);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? data : { type: 1 },
    shouldUnregister: true,
  });
  
  const typeValue = watch("type");
  
  // Register type for validation
  useEffect(() => {
    register("type", { required: "النوع مطلوب" });
    // Set default type value
    if (!data || isAdd) {
      setValue("type", 1);
    }
  }, [register, setValue, data, isAdd]);


  useEffect(() => {
    if (data && !isAdd) {
      reset({
        phone: data.phone || "",
        type: data.type || 1,
      });
      setValue("type", data.type || 1);
    } else {
      reset({ 
        phone: "",
        type: 1 
      });
      setValue("type", 1);
    }
  }, [data, isAdd, reset, setValue]);

  const typeOptions = [
    { value: 1, label: "سكرتارية" },
    { value: 2, label: "علمي" },
  ];

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "white",
      color: "#374151",
      borderRadius: "12px",
      border: "2px solid #E5E7EB",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      "&:hover": {
        borderColor: "#FF8C00",
      },
      "&:focus": {
        borderColor: "#FF8C00",
        boxShadow: "0 0 0 3px rgba(255, 140, 0, 0.1)",
      },
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      color: isSelected ? "white" : "#374151",
      backgroundColor: isSelected ? "#FF8C00" : isFocused ? "#FFF3E0" : "white",
      "&:hover": {
        backgroundColor: isSelected ? "#FF8C00" : "#FFF3E0",
      },
    }),
    placeholder: (styles) => ({
      ...styles,
      color: "#9CA3AF",
    }),
  };

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة رقم أسيستانت" : "تعديل رقم أسيستانت"}
      </Heading>
    </Box>
  );

  const onSubmit = async (formData) => {
    // Validate required fields
    if (!formData.phone) {
      return;
    }
    
    // Ensure type has a value (default to 1 if not set)
    if (!formData.type) {
      formData.type = 1;
    }
    
    const action = () => {
      dispatch(closeCreateSubjectAssistPhone());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      await dispatch(createSubjectAssistPhoneRequest(formData, action));
    } else {
      await dispatch(
        editSubjectAssistPhoneRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateSubjectAssistPhone());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openPhone}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack dir="rtl" w="100%" alignItems="flex-start" spacing={4}>

          <Box w="100%">
            <MainInput
              label="رقم الهاتف"
              error={errors?.phone?.message}
              placeholder=" اكتب رقم الهاتف"
              register={register}
              name="phone"
              required
            />
          </Box>

          <Box w="100%">
            <FormLabel>النوع:</FormLabel>
            <Select
              options={typeOptions}
              onChange={(selected) => {
                setValue("type", selected?.value || 1, { shouldValidate: true });
              }}
              value={typeOptions.find(option => option.value === (typeValue || 1)) || typeOptions[0]}
              styles={colourStyles}
              placeholder="اختر النوع"
            />
            {errors?.type && (
              <Text color="red.500" fontSize="14px" mt="5px">
                {errors.type.message}
              </Text>
            )}
          </Box>
        </VStack>
      </form>
    </MainModel>
  );
};

export default AddSubjectAssistPhone;

